import { Container } from "@mui/material";
import { useLoaderData, useNavigation } from "react-router";
import { CasesData } from "../App.tsx";
import CasesList from "../components/CasesList.tsx";
import Loading from "../components/general/Loading";

const GetCases = () => {
  const { cases, accessNames } = useLoaderData<CasesData>();
  const navigation = useNavigation();

  if (navigation.state === "loading") {
    return <Loading />;
  }

  return (
    <Container maxWidth="lg">
      <CasesList cases={cases} accessNames={accessNames} />
    </Container>
  );
};

export default GetCases;
